import { defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { usePathContext } from '../../../../context/PathContext.js';
import classNames from 'classnames';
import PlainText from '../../../../components/PlainText/index.js';
import styles from './styles.css.js';

var QuestionHeader = function QuestionHeader(_ref) {
  var question = _ref.question;
  var pathContext = usePathContext();
  var questionText = question.commonFields.questionText;
  var questionSubText = question.commonFields.questionSubText;

  if ((questionText === null || questionText === void 0 ? void 0 : questionText.plainText) || (questionSubText === null || questionSubText === void 0 ? void 0 : questionSubText.plainText)) {
    return React.createElement("div", {
      className: classNames(styles.question, _defineProperty({}, styles.placementDefault, pathContext.pathPlacement === 'default'))
    }, questionText && React.createElement("h3", {
      className: classNames(styles.questionText, _defineProperty({}, styles.placementDefault, pathContext.pathPlacement === 'default')),
      "data-testid": "path-question-header-text"
    }, React.createElement(PlainText, {
      plainTextEntry: questionText
    })), questionSubText && React.createElement("p", {
      className: styles.questionSubText,
      "data-testid": "path-question-sub-header-text"
    }, React.createElement(PlainText, {
      plainTextEntry: questionSubText
    })));
  }

  return null;
};

export default QuestionHeader;
//# sourceMappingURL=index.js.map
